import React from 'react'
import './Exitcasepopupcdmqb.css'
// All classNames are suffixed with "CDMQB" so they never collide with the
// default skin's CSS if that stylesheet happens to be loaded too.

export default function ExitCasePopupCDMQB(props) {
    return (
        <div className={`exitCasePageContainerCDMQB ${props.displayExitCasePrompt ? '' : 'hideExitCasePromptCDMQB'}`}>
            <div className='exitCaseBackdropCDMQB' />
            <div className='exitCaseContainerCDMQB'>
                <div className='exitCaseHeaderContainerCDMQB'>
                    <p className='exitCaseHeaderTextCDMQB'>Exit Case?</p>
                </div>
                <div className='exitCaseBodyContainerCDMQB'>
                    <p className='exitCaseBodyTextCDMQB'>Are you sure you want to exit the case? Your progress will be saved to continue at a later point.</p>
                </div>
                <div className='exitCaseFooterContainerCDMQB'>
                    <button className='exitCaseFooterButtonCDMQB' onClick={props.cancelExitCase}>Cancel</button>
                    <button className='exitCaseFooterButtonCDMQB' onClick={props.confirmExitCase}>Exit Case</button>
                </div>
            </div>
        </div>
    )
}